import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { refreshMediaToken } from '../lib/api';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate('/login'); return; }
    (async () => {
      try {
        const res = await api.post('/auth/session', { session_id: sessionId });
        localStorage.setItem('session_token', res.data.session_token);
        refreshMediaToken();
        setUser(res.data.user);
        window.history.replaceState({}, document.title, '/app/today');
        navigate('/app/today', { state: { user: res.data.user } });
      } catch (e) {
        setError('Sign-in failed. Please try again.');
        setTimeout(() => navigate('/login'), 1800);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="h-dvh flex items-center justify-center bg-[hsl(var(--background))]">
      <div className="flex flex-col items-center gap-3">
        <div className="h-10 w-10 rounded-2xl bg-[hsl(var(--primary))] animate-pulse" />
        <p className="text-sm text-[hsl(var(--muted-foreground))]">{error || 'Signing you in…'}</p>
      </div>
    </div>
  );
}
